import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type WithOnboardingAnalyticsCategory } from './onboardingAnalytics';
import META from './useTrackViewedOnboardingInviteMembers.meta';

export type ViewedOnboardingInviteMembersParams = WithOnboardingAnalyticsCategory;

export const useTrackViewedOnboardingInviteMembers = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedOnboardingInviteMembers = useCallback(
    (params: ViewedOnboardingInviteMembersParams) => {
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackViewedOnboardingInviteMembers };
};
